<div
  class="content-title card-header filter-head__header"
  (click)="activeToggle = !activeToggle; expandedFilters.emit(activeToggle)"
  data-bs-toggle="collapse"
  data-bs-target="#filter"
>
  <h4 class="cpa card-title mb-0">
    <i class="fa-sharp fa-solid fa-filter me-2"></i
    >{{ 'common.filters.title' | translate }}
  </h4>
  <div class="tools">
    <a class="SlideToolHeader" [ngClass]="{expand: activeToggle}">
      <i class="fa-sharp fa-solid fa-chevron-down"></i>
    </a>
  </div>
</div>

<div class="cm-content-body form excerpt collapse" id="filter">
  <div class="card-body">
    <div class="row align-items-end justify-content-start">
      <div
        *ngFor="let filter of filters; trackBy: trackByFilter"
        class="col-xl-3 col-sm-6 filter-head__field"
      >
        <ng-container *ngIf="filter.type === 'text'">
          <gatewee-input-v2
            type="text"
            class="form-control mb-xl-0 mb-3"
            [(value)]="filter.value"
            [placeholder]="filter.placeholder || filter.label"
            [label]="filter.label"
          ></gatewee-input-v2>
        </ng-container>

        <ng-container *ngIf="filter.type === 'select'">
          <gatewee-select-v3
            id="payment-method"
            [items]="$any(filter.data)"
            [(ngModel)]="filter.value"
            [placeholder]="filter.placeholder || filter.label"
            [label]="filter.label"
          ></gatewee-select-v3>
        </ng-container>

        <ng-container *ngIf="filter.type === 'date'">
          <gatewee-datepicker-v2
            [label]="filter.label"
            placeholder="yyyy-mm-dd"
            [(ngModel)]="filter.value"
            [ngModelOptions]="{standalone: true}"
          ></gatewee-datepicker-v2>
        </ng-container>
      </div>

      <ng-container *ngIf="enableDateRange">
        <div class="col-xl-3 filter-head__field">
          <gatewee-datepicker-range
            #dateRangePicker
            [label]="'common.filters.dateRange' | translate"
            (dateChange)="setDateRange($event)"
          ></gatewee-datepicker-range>
        </div>
      </ng-container>

      <div class="col-xl-3 content-btn">
        <div class="filter-head__actions">
          <button
            class="btn-filter btn-primary me-2"
            title="Click here to Search"
            type="button"
            (click)="applyFilters()"
            [disabled]="!validateFilters() || loading"
          >
            <i
              class="fa"
              [ngClass]="{'fa-filter': !loading, 'fa-spinner fa-spin': loading}"
            ></i>
            {{ 'common.filters.submit' | translate }}
          </button>
          <button
            class="btn-filter btn-danger light ms-1"
            title="Click here to remove filter"
            type="button"
            (click)="removeFilters()"
            [disabled]="loading"
          >
            <i class="fa fa-times me-1"></i
            >{{ 'common.filters.remove' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
